<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Canal</mat-label>
                    <mat-select data-select-channelId formControlName="channelType" required>
                        @for (channelType of _context.channelTypes; track channelType) {
                            <mat-option data-select-listing-type-option [value]="channelType" [disabled]="channelType !== ChannelType.Email">
                                {{ channelTypeLabels.get(channelType) }}
                            </mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.channelType?.required && (formGroup.controls['channelType']?.dirty || formGroup.controls['channelType'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Canal' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce paramètre permet de définir le type de canal de reception utilisé.<br>Pour l'instant seul les canaux de type E-mail sont disponibles.<br>Ce type de canal peut également être utilisé pour du fax to mail. "
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>Adresse</mat-label>
                    <mat-select data-select-address formControlName="addressId" required>
                        @for (address of _context.addresses; track address) {
                            <mat-option data-select-listing-type-option [value]="address.id">{{ address.displayName }}</mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.addressId?.required && (formGroup.controls['addressId']?.dirty || formGroup.controls['addressId'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Adresse' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce paramètre définit qu'elle sera l'adresse e-mail de reception des messages qui seront convertis en dossier pour la vue courante.<br>Vous pouvez paramétrer une nouvelle adresse de reception au niveau des adresses e-mails de l'organisation."
                    tooltipPosition="right"></fa-icon>
            </div>

            @if (currentViewType === enumViewType.Box) {
                <div class="form-item form-item-help">
                    <mat-form-field class="with-info-icon">
                        <mat-label>Bannette par défaut</mat-label>
                        <mat-select data-select-defaultBoxId formControlName="defaultBoxId" required>
                            @for (box of _context.boxes; track box) {
                                <mat-option data-select-listing-type-option [value]="box.id">{{ box.displayName }}</mat-option>
                            }
                        </mat-select>
                        @if (formGroupErrors?.defaultBoxId?.required && (formGroup.controls['defaultBoxId']?.dirty || formGroup.controls['defaultBoxId'].touched)) {
                            <mat-error data-input-title-error>Le champ 'Bannette par défaut' est obligatoire</mat-error>
                        }
                    </mat-form-field>
                    <fa-icon [icon]="faCircleInfo" class="info-icon" hubToolTip="TODO Bannette par défaut" tooltipPosition="right"></fa-icon>
                </div>
            }

            <div class="form-item form-item-help">
                <mat-form-field class="with-info-icon">
                    <mat-label>État par défaut</mat-label>
                    <mat-select data-select-defaultStateId placeholder="État par défaut" formControlName="defaultStateId" required>
                        @for (folderState of _context.folderStates; track folderState) {
                            <mat-option data-select-listing-type-option [value]="folderState.id">{{ folderState.name }}</mat-option>
                        }
                    </mat-select>
                    @if (formGroupErrors?.defaultStateId?.required && (formGroup.controls['defaultStateId']?.dirty || formGroup.controls['defaultStateId'].touched)) {
                        <mat-error data-input-title-error>Le champ 'État par défaut' est obligatoire</mat-error>
                    }
                </mat-form-field>
                <fa-icon
                    [icon]="faCircleInfo"
                    class="info-icon"
                    hubToolTip="Ce paramètre défini l'état par défaut que prendra le dossier créé à la reception d'un e-mail sur ce canal.<br>Si necessaire, l'état du dossier pourra être géré plus finement par un processus ou par le workflow."
                    tooltipPosition="right"></fa-icon>
            </div>

            <div class="checkbox-group">
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="ocrEnabled">Activer l'OCR</mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, une reconnaissance optique de caractères sera effectuée sur les pièces-jointes du mail. Le résultat de l'OCR pourra être utilisé dans les processus associés au canal de reception.<br><br><b>Cette option n'est pas encore implémentée.</b>"
                        tooltipPosition="right"></fa-icon>
                </div>
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="customerIdentificationEnabled">Activer l'identification du client (RAD)</mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, les processus de type 'Identification du client' associés au canal seront executés.<br>Ces processus permettent d'identifier le client à l'origine du mail en fonction de critères comme l'adresse de l'emetteur, le contenu de l'objet ou le contenu du corps du mail."
                        tooltipPosition="right"></fa-icon>
                </div>
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="documentIdentificationEnabled">
                        Activer l'identification du type de document (RAD)
                    </mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, les processus de type 'Identification du type de document' associés au canal seront executés.<br>Ces processus permettent d'identifier à quel type de document correspond le mail reçu en fonction de critères comme l'adresse de l'emetteur, le client, le contenu de l'objet ou le contenu du corps du mail."
                        tooltipPosition="right"></fa-icon>
                </div>
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="attributesAssignmentEnabled">Activer l'assignation d'attribut (RAD)</mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, les processus de type 'Assignation d'attributs' associés au canal seront executés.<br>Ces processus permettent d'alimenter des attributs du dossier en fonction de critères comme l'adresse de l'emetteur, le client, le type de document, le contenu de l'objet ou le contenu du corps du mail."
                        tooltipPosition="right"></fa-icon>
                </div>
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="ladEnabled">Activer la LAD</mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, une lecture automatique des documents sera effectuée sur les pièces-jointes du mail. Le résultat de la LAD pourra être utilisé pour alimneter des attributs du dossier.<br><br><b>Cette option n'est pas encore implémentée.</b>"
                        tooltipPosition="right"></fa-icon>
                </div>
                <div class="form-item form-item-help">
                    <mat-checkbox class="with-info-icon accent-button" formControlName="autoLinkEnabled">Activer le rattachement automatique</mat-checkbox>
                    <fa-icon
                        [icon]="faCircleInfo"
                        class="info-icon"
                        hubToolTip="Si cette option est activée, les processus de type 'Rattachement automatique' associés au canal seront executés.<br>Ces processus permettent de rattacher le mail reçu à un dossier existant en fonction de critères comme l'adresse de l'emetteur, le client, le type de document, le contenu de l'objet ou le contenu du corps du mail."
                        tooltipPosition="right"></fa-icon>
                </div>
            </div>
        </div>
    </form>
    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
